// Đơn vị thời gian cổ (UI_SPEC §15): 1 khắc = 15 phút, 1 canh giờ = 2 giờ.
import { t } from './t';

export const KHAC_MS = 15 * 60 * 1000;
export const CANH_MS = 2 * 60 * 60 * 1000;
export const DAY_MS = 24 * 60 * 60 * 1000;
const JUST_NOW_MS = 45 * 1000;

/** Giờ tương đối cho Truyền Âm: vừa xong · N khắc trước · N canh giờ trước · N ngày trước. */
export function relativeTime(thenMs: number, nowMs: number): string {
  const d = Math.max(0, nowMs - thenMs);
  if (d < JUST_NOW_MS) return t('time.justNow');
  if (d < CANH_MS) return t('time.keAgo', { n: Math.max(1, Math.floor(d / KHAC_MS)) });
  if (d < DAY_MS) return t('time.watchAgo', { n: Math.floor(d / CANH_MS) });
  return t('time.dayAgo', { n: Math.floor(d / DAY_MS) });
}

/** Quãng đã qua (Hồi Sơn), làm tròn XUỐNG: "2 canh giờ" · "3 khắc" · "1 ngày 4 canh giờ". */
export function elapsedText(ms: number): string {
  const d = Math.max(0, ms);
  if (d >= DAY_MS)
    return t('time.elapsed.day', { d: Math.floor(d / DAY_MS), c: Math.floor((d % DAY_MS) / CANH_MS) });
  if (d >= CANH_MS) return t('time.elapsed.watch', { n: Math.floor(d / CANH_MS) });
  if (d >= KHAC_MS) return t('time.elapsed.ke', { n: Math.floor(d / KHAC_MS) });
  return t('time.elapsed.lt');
}

/** Đếm ngược, làm tròn LÊN: "còn 3 canh giờ" (≥ 1 canh) · "còn 2 khắc" · "đã hết". */
export function remainingText(ms: number): string {
  if (ms <= 0) return t('time.left.none');
  if (ms >= CANH_MS) return t('time.left.watch', { n: Math.ceil(ms / CANH_MS) });
  return t('time.left.ke', { n: Math.ceil(ms / KHAC_MS) });
}
